'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _eventEmitter = require('./eventEmitter');

var _eventEmitter2 = _interopRequireDefault(_eventEmitter);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseModalProvider = function (_Component) {
  _inherits(BaseModalProvider, _Component);

  function BaseModalProvider() {
    _classCallCheck(this, BaseModalProvider);

    return _possibleConstructorReturn(this, (BaseModalProvider.__proto__ || Object.getPrototypeOf(BaseModalProvider)).apply(this, arguments));
  }

  _createClass(BaseModalProvider, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      _eventEmitter2.default.on('showModal', function (args) {
        var _props;

        return (_props = _this2.props).showModal.apply(_props, _toConsumableArray(args));
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _eventEmitter2.default.removeListener('showModal');
    }
  }, {
    key: 'hideModal',
    value: function hideModal(id) {
      var _this3 = this;

      var delayBeforeRemoveMsec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.DELAY_BEFORE_REMOVE_MSEC;

      this.props.hideModal(id);
      setTimeout(function () {
        _this3.props.removeModal(id);
      }, delayBeforeRemoveMsec);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        null,
        this.props.modalProvider.stack.map(function (modal) {
          return _react2.default.createElement(modal.component, _extends({
            key: '@' + _this4.constructor.name + '_MODAL_' + modal.id
          }, modal.props, {
            hideModal: function hideModal() {
              return _this4.hideModal(modal.id, modal.delayBeforeRemoveMsec);
            },
            show: modal.show
          }));
        })
      );
    }
  }]);

  return BaseModalProvider;
}(_react.Component);

exports.default = BaseModalProvider;


BaseModalProvider.propTypes = {
  showModal: _propTypes2.default.func.isRequired,
  hideModal: _propTypes2.default.func.isRequired,
  removeModal: _propTypes2.default.func.isRequired,
  modalProvider: _propTypes2.default.shape({
    stack: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      id: _propTypes2.default.number.isRequired,
      component: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]).isRequired,
      props: _propTypes2.default.object,
      show: _propTypes2.default.bool.isRequired
    }))
  }).isRequired
};